import { render, staticRenderFns } from "./warelives.vue?vue&type=template&id=e2ca68a8&scoped=true"
import script from "./warelives.vue?vue&type=script&lang=js"
export * from "./warelives.vue?vue&type=script&lang=js"
import style0 from "./warelives.vue?vue&type=style&index=0&id=e2ca68a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ca68a8",
  null
  
)

export default component.exports